"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsHistory = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var utils_1 = require("../../../../shared/core/components/RegisterSummary/utils");
var registers_1 = require("../../../../shared/core/utils/registers");
var typography_1 = require("../../../../shared/core/utils/typography");
var kapi_meter_reads_1 = require("../../../kapi-meter-reads");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var analytics_subjects_1 = require("../../analytics-subjects");
var components_1 = require("../../components");
var copy_1 = require("../../copy");
var utils_2 = require("../../utils");
var TabWrapper = function (_a) {
    var children = _a.children, elecSupplies = _a.elecSupplies, activeTab = _a.activeTab, setCurrentIndex = _a.setCurrentIndex;
    var meterReadsHistory = (0, core_1.useLinks)().meterReadsHistory;
    var _b = (0, core_1.useComponents)(), Card = _b.Card, TabList = _b.TabList, Tab = _b.Tab, TabPanel = _b.TabPanel;
    var navigate = (0, ui_tools_1.useNavigate)();
    var setActiveTab = function (selectedIndex) {
        var supplyUrl = "".concat(meterReadsHistory({
            fuelType: 'electricity',
        }), "?supplyIndex=").concat(selectedIndex);
        navigate(supplyUrl, { replace: true });
        setCurrentIndex(selectedIndex);
    };
    // create string for tab title
    // register names joined with slashes
    var names = elecSupplies.filter(utils_2.filterSupplies).map(function (_a) {
        var registers = _a.registers;
        return registers
            .filter(utils_2.filterTimingCategory)
            .map(function (_a, index) {
            var timingCategory = _a.timingCategory;
            var label = (0, utils_1.getFriendlyLabel)(timingCategory);
            if (label) {
                var copyLabel = (0, registers_1.getCopyKey)(label);
                if (copyLabel) {
                    return (react_1.default.createElement(registers_1.RegisterLabel, { friendlyLabel: label, capitalise: true, key: index }));
                }
            }
        })
            .filter(Boolean);
    });
    var tabRefs = names.map(function () { return (0, react_1.createRef)(); });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(TabList, { "data-testid": "read-history-tabs", setActiveTab: setActiveTab, tabIds: names, activeTab: activeTab, tabRefs: tabRefs }, names.map(function (tabName, i) { return (react_1.default.createElement(Tab, { key: "register-".concat(i), "data-testid": "read-history-tab" }, tabName.length > 1
            ? tabName.map(function (n, j) {
                return j === tabName.length - 1 ? (react_1.default.createElement(react_1.Fragment, { key: "".concat(j, "-").concat(i) }, n)) : (react_1.default.createElement(react_1.Fragment, { key: "".concat(j, "-").concat(i) },
                    n,
                    " / "));
            })
            : tabName[0] &&
                (0, react_1.cloneElement)(tabName[0], { key: "tabname-single-".concat(i) }))); })),
        react_1.default.createElement(TabPanel, { as: Card }, children)));
};
function PageContentMain(_a) {
    var fuel = _a.fuel;
    var _b = (0, core_1.useComponents)(), Card = _b.Card, Checkbox = _b.Checkbox, Margin = _b.Margin, Heading1 = _b.Heading1, Stack = _b.Stack;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), Copy = _c.Copy, copy = _c.copy;
    var _d = __read((0, react_1.useState)(true), 2), hideEstimates = _d[0], setHideEstimates = _d[1];
    var supplies = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext).supplies;
    var search = window.location.search;
    var currentSupplyIndex = (0, core_1.getValueFromQueryParams)('supplyIndex', search) || '0';
    var _e = __read((0, react_1.useState)(parseInt(currentSupplyIndex)), 2), currentIndex = _e[0], setCurrentIndex = _e[1];
    // TODO move isComplex to context
    var isComplex = (0, utils_2.hasComplexSuppliesContext)(supplies.electricity);
    var Wrapper = isComplex && fuel === 'electricity'
        ? function (_a) {
            var children = _a.children;
            return (react_1.default.createElement(TabWrapper, { elecSupplies: supplies.electricity, activeTab: currentIndex, setCurrentIndex: setCurrentIndex }, children));
        }
        : Card;
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Copy, { copyKey: "historyBackToMeterReadings" }),
            react_1.default.createElement(Margin, { top: 1 },
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "historyHeading", values: { fuel: (0, typography_1.capitalise)(fuel) } })))),
        react_1.default.createElement(Wrapper, null,
            react_1.default.createElement(Copy, { copyKey: "historyWrongMeterReadingsMessage" }),
            react_1.default.createElement(Checkbox, { id: "toggle-estimates", label: copy('historyHideEstimatesCheckboxLabel'), onChange: function (_a) {
                    var target = _a.target;
                    return setHideEstimates(target.checked);
                }, checked: hideEstimates, "data-testid": "read-history-toggle-estimates" }),
            react_1.default.createElement(Margin, { vertical: 6 },
                react_1.default.createElement(components_1.MeterReadingsTable, { isComplex: isComplex, selectedFuel: fuel, hideEstimates: hideEstimates })))));
}
exports.MeterReadingsHistory = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var selectedFuel = _a.selectedFuel;
    var meterReads = core_1.configService.getConfig().meterReads;
    if (meterReads === null || meterReads === void 0 ? void 0 : meterReads.kapiOnly) {
        return react_1.default.createElement(kapi_meter_reads_1.KapiMeterReadingsHistory, { selectedFuel: selectedFuel });
    }
    return (react_1.default.createElement(components_1.MeterReadingsPage, { name: analytics_subjects_1.METER_READINGS_HISTORY, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b), selectedFuel: selectedFuel },
        react_1.default.createElement(PageContentMain, { fuel: selectedFuel })));
});
